import "@babel/polyfill";
import { tns } from "tiny-slider/src/tiny-slider";

function tnsInit() {
  let sliderNodes = Array.from(document.querySelectorAll('.js-tiny-carousel'));

  if (sliderNodes.length > 0) {

    sliderNodes.forEach( carousel => {
      //
      let isCards = Array.from(carousel.querySelectorAll('.is-card'));      

      let count = 0;

      if (isCards.length) {
        count = parseInt(isCards.length);
      } else {
        count = parseInt(carousel.dataset.carouselCount);
      }      
      
      const cards = parseInt(carousel.dataset.carouselCards);
      const autoplay = carousel.dataset.carouselAutoplay ? carousel.dataset.carouselAutoplay : false;
      const carouselType = carousel.dataset.carouselType;
      const speed = parseInt(carousel.dataset.carouselSpeed);
      let navigationElement;
      let controls = true;
      
      if (carousel.dataset.carouselNavigationElement != undefined) {
        navigationElement = '#'+carousel.dataset.carouselNavigationElement;
      } else {
        navigationElement = false;
        controls = false;
      }

      let controlsElement = carousel.nextElementSibling;      

      if(controlsElement) {
        if(controlsElement.classList.contains('tiny-slider-controls')) {
          if (count <= cards) {
            controlsElement.classList.add("hidden");
          } else {
            controlsElement.classList.remove("hidden");
          }
        }
      }      
  
      let responsiveSettings;
  
      switch(carouselType) {      
        case 'hero-accordian':        
          responsiveSettings = {
            0: {
              items: 1,
              margin: 0,
              slideBy: 1,
            },
            992: {
              // items: 5,
              // margin: 0,
              // slideBy: 5,
              disable: true,
            }
          }
        break;
  
        case 'cards-timeline':
          responsiveSettings = {
            0: {
              items: 1,
              margin: 0,
              slideBy: 1,
            },
            768: {
              items: 2,
              margin: 0,
              slideBy: 2,
            },
            1180: {
              items: cards,
              margin: 0,
              slideBy: cards,
            }
          }
        break;
  
        case 'cards-regular':
          responsiveSettings = {
            0: {
              items: 1,
              margin: 24,
              slideBy: 1
            },
            680: {
              items: 2,
              margin: 24,
              slideBy: 2
            },
            1180: {
              items: cards,
              margin: 0,
              slideBy: cards
            }
          }
        break;
    
        case 'uberflip':
  
          responsiveSettings = {
            0: {
              items: 1,
              margin: 24,
              slideBy: 1
            },
            680: {
              items: 2,
              margin: 24,
              slideBy: 2
            },
            840: {
              items: 3,
              margin: 0,
              slideBy: 3
            },
            1180: {
              items: 4,
              margin: 0,
              slideBy: 4
            }
          }
        break;
  
        case 'resourcesBlock':
  
          responsiveSettings = {
            0: {
              items: 1,
              margin: 24,
              slideBy: 1
            },
            768: {
              items: 2,
              margin: 24,
              slideBy: 2
            },
            992: {
              items: 3,
              margin: 0,
              slideBy: 3
            },
            1180: {
              items: 4,
              margin: 0,
              slideBy: 4
            }
          }
        break;
  
        case 'cards-spotlight':
          responsiveSettings = {
            0: {
              items: cards,
              margin: 0,
              slideBy: cards
            }
          }
        break;
  
        case 'cards-advertisements':
          responsiveSettings = {
            0: {
              items: 1,
              margin: 24,
              slideBy: 1,
              autoplay: autoplay,
              loop: true
            }
          }
        break;
      }
  
      if(count > cards) {
        if (carouselType === 'hero-accordian') {
          // Settings for the Hero Accordian block
          const slider = tns({
            container: carousel,
            items: cards,
            slideBy: "page",
            loop: true,          
            nextButton: '.accordian-button-next',
            prevButton: '.accordian-button-prev',          
            nav: false,
            autoplayButton: false,
            autoplay: false,
            mouseDrag: false,
            responsive: responsiveSettings,
          });
        }
        else if (carouselType === 'cards-timeline') {
          // Settings for the Hero Timeline block
          const slider = tns({
            container: carousel,
            items: cards,
            slideBy: "page",
            loop: false,
            // controls: controls,
            // controlsContainer: navigationElement,
            nextButton: '.button-next',
            prevButton: '.button-prev',
            // navPosition: 'bottom',
            nav: false,
            autoplayButton: false,
            autoplay: false,
            mouseDrag: false,
            responsive: responsiveSettings,
          });
        }
        else if (carouselType === 'thirty-pix-banner') {        
          // Settings for the Hero Timeline block
          const slider = tns({
            container: carousel,
            items: cards,
            slideBy: 1,
            loop: true,          
            navPosition: 'bottom',
            autoplayButton: false,
            mouseDrag: true,
            autoplay: true,
            autoplayTimeout : speed,
            // mode: 'gallery',      
            controls: false,    
            autoHeight: true,
          });
        }

        else if (carouselType === 'testimonial') {        
          // Settings for the Hero Timeline block
          const slider = tns({
            container: carousel,
            items: cards,
            slideBy: 1,
            loop: true,          
            navPosition: 'bottom',
            autoplayButton: false,
            mouseDrag: true,
            autoplay: true,
            autoplayTimeout : speed,
            // mode: 'gallery',      
            controls: false,    
            autoHeight: true,
          });
        }

        else {
          const slider = tns({
            container: carousel,
            items: cards,
            slideBy: "page",
            loop: false,
            controls: controls,
            controlsContainer: navigationElement,
            navPosition: 'bottom',
            autoplayButton: false,
            mouseDrag: true,
            responsive: responsiveSettings,
          });
        }
      } else if (count === cards && carouselType === 'testimonial') {
        // Handle single testimonial items - initialize carousel but disable navigation
        const slider = tns({
          container: carousel,
          items: 1,
          slideBy: 1,
          loop: false,
          nav: false,
          controls: false,
          autoplay: false,
          mouseDrag: false,
          autoHeight: true,
        });
      }
    })
  }
}

tnsInit();

// Convert jQuery code to vanilla JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Bootstrap Carousel initialization
  const carousels = document.querySelectorAll('.carousel');
  carousels.forEach(function(carousel) {
    new bootstrap.Carousel(carousel);
  });

  // Call normalizeSlideHeights on window load, resize, and orientation change
  window.addEventListener('load', normalizeSlideHeights);
  window.addEventListener('resize', normalizeSlideHeights);
  window.addEventListener('orientationchange', normalizeSlideHeights);

  function normalizeSlideHeights() {
    const carousels = document.querySelectorAll('.carousel');
    carousels.forEach(function(carousel) {
      const items = carousel.querySelectorAll('.carousel-item');
      
      // Reset the height
      items.forEach(function(item) {
        item.style.minHeight = '0';
      });
      
      // Calculate max height
      let maxHeight = 0;
      items.forEach(function(item) {
        const height = item.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      
      // Set the height
      items.forEach(function(item) {
        item.style.minHeight = maxHeight + 'px';
      });
    });
  }
});

